import { routes } from "@routes";
import { authService } from "@services";
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

 // eslint-disable-next-line 
type ReponseType = any;

export class ApiClientBase {

    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        const access_token = await authService.getAccessToken();
        if (access_token) {
            options.headers["Authorization"] = `Bearer ${access_token}`; 
        }
        return Promise.resolve(options);
    }


    protected transformResult(url: string, response: Response, processor: (response: Response) => Promise<ReponseType>): Promise<ReponseType> { 
        if (response && response.status == 403) {
            history.replace(routes.authenticationError.path);
            return Promise.resolve();
        }
        return processor(response);
    }
}
